import * as XLSX from 'xlsx';
import { generateAnalyticsSheet, generateTextMessagesSheet, generateVoiceMailsSheet } from './generateExcelFile_default';

// 3. Voice Mails Sheet
const generateVoiceMailsSheets = (voiceMails) => {
  const voiceData1 = [
    ['Conversation ID', 'Timestamp', 'Content', 'Duration', 'Phone Number']
  ];
  const voiceData2 = [
    ['Conversation ID', 'Timestamp', 'Content', 'Duration', 'Phone Number']
  ];

  voiceMails.forEach(message => {
    const match = message.message_content.match(/(\d[\s-]?){7}\d/);
    const phoneNumber = match ? match[0] : '-';
    if (message.conversation_id.startsWith('concierge::CLID8855::+85228372000')) {
      voiceData1.push([
        message.conversation_id || '',
        phoneNumber || '',
        message.timestamp || '',
        message.message_content || '',
        message.duration || '',
      ]);
    } else {
      voiceData2.push([
        message.conversation_id || '',
        phoneNumber || '',
        message.timestamp || '',
        message.message_content || '',
        message.duration || ''
      ]);
    }
  });

  const voiceSheet1 = XLSX.utils.aoa_to_sheet(voiceData1);
  const voiceSheet2 = XLSX.utils.aoa_to_sheet(voiceData2);
  // Style the voice mails sheet
  voiceSheet1['!cols'] = [
    { width: 20 },
    { width: 20 },
    { width: 20 },
    { width: 60 },
    { width: 10 },
  ];

  voiceSheet2['!cols'] = [
    { width: 20 },
    { width: 20 },
    { width: 20 },
    { width: 60 },
    { width: 10 },
  ];

  return [voiceSheet1, voiceSheet2];
}


export function generateExcelFile__CLID8855(textMessages, voiceMails, analytics, startDateStr, endDateStr) {
  // Create a new workbook
  const workbook = XLSX.utils.book_new();

  // 1. Analytics Sheet
  if (analytics) {
    const analyticsSheet = generateAnalyticsSheet(analytics, startDateStr, endDateStr, textMessages, voiceMails);
    XLSX.utils.book_append_sheet(workbook, analyticsSheet, 'Analytics');
  }

  // 2. Text Messages Sheet
  if (textMessages.length > 0) {
    const textSheet = generateTextMessagesSheet(textMessages);
    XLSX.utils.book_append_sheet(workbook, textSheet, 'Text Messages');
  }

  // 3. Voice Mails Sheet
  if (voiceMails.length > 0) {
    const [voiceSheet1, voiceSheet2] = generateVoiceMailsSheets(voiceMails);
    XLSX.utils.book_append_sheet(workbook, voiceSheet1, '利園二期');
    XLSX.utils.book_append_sheet(workbook, voiceSheet2, '太古坊');
  }

  // Generate Excel file and download
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `conversations_export_${startDateStr}_to_${endDateStr}.xlsx`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
